// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1UMk7","rightAdornment":"Header_rightAdornment__3IB85"};